module.exports = __webpack_public_path__ + "news.svg?519cd43ae1a4c10ed7fe79d599001b7b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news.svg
// module id = 125
// module chunks = 0